<div class="all-filters">
  <div class="all-filters-title">
    {{ 'browse.filterSort.filters.allFilters.title' | translate }}
  </div>

  <div class="filters">
    @for (filter of filters; track $index) {
      <app-all-filters-field
        [filter]="filter"
        [unit]="unit | async"
        [sport]="selectedSport$ | async"
        [filtersCleared]="filtersCleared"
        (changeSelectedOptions)="onChangeSelectedOptions($event)" />
    }
  </div>

  <div class="all-filters-buttons">
    <button class="clear-btn" (click)="onClearFilters()">
      {{ 'browse.filterSort.filters.allFilters.clearAllBtnTitle' | translate }}
    </button>
    <button
      class="filter-btn"
      (click)="onApplyFilters()"
      [disabled]="!isFilteringEnabled">
      {{ 'browse.filterSort.filters.allFilters.filterAllBtnTitle' | translate }}
    </button>
  </div>
</div>
